module.exports = "/_next/static/images/optimised-signup-33e472d5d8aacd7b1e9657afa27c928f.png";